<template>
  <CRow class="row-wrapper align-items-center gap-20 px-3">
    <CIcon
      v-if="infoLeft"
      name="question"
      size="custom-size"
      :height="23"
      viewBox="0 0 32 32"
      v-c-tooltip="{
        content: $t('campaign.campaignResult.list.engagment.text.info'),
        placement: 'bottom-start',
      }"
    />
    <VueSvgGauge
      :start-angle="-90"
      :end-angle="90"
      :value="engagementValue ? engagementValue : 0"
      :scale-step="3"
      :separator-step="3"
      :min="0"
      :max="3"
      :inner-radius="90"
      :gauge-color="[
        { offset: 0, color: '#ff0000' },
        { offset: 50, color: '#ee9200' },
        { offset: 100, color: '#17d26f' },
      ]"
      :scale-interval="0"
    >
      <p class="pointer animate autoAnimation" :class="rotatePointer(engagementValue)"></p>
    </VueSvgGauge>
    <div class="inner-text pt-1">
      <div class="engagement font-weight-bold">
        <span class="pl-1 engagement-span engagement-span-success font-sm" :class="engagementTextClass">{{ engagementState }}</span>
        <div class="pl-1 engagement-span text-black font-sm">{{ engagementDescription }}</div>
      </div>
    </div>
    <CIcon
      v-if="!infoLeft"
      name="question"
      size="custom-size"
      :height="23"
      viewBox="0 0 32 32"
      v-c-tooltip="{
        content: $t('campaign.campaignResult.dashboard.engagment.text.info'),
        placement: 'bottom-start',
      }"
    />
  </CRow>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import { VueSvgGauge } from 'vue-svg-gauge'

const ENGAGEMENT_TYPES = {
  SUCCESS: 1,
  WARNING: 2,
  DANGER: 3,
}

export default {
  props: {
    engagementResultType: Number,
    noDataTranslation: {
      type: Object,
      default: () => {},
    },
    infoLeft: {
      type: Boolean,
      default: () => false,
    },
  },
  components: {
    apexchart: VueApexCharts,
    VueSvgGauge,
  },
  computed: {
    engagementValue() {
      if (!this.engagementResultType) return

      const gaugeValues = {
        [ENGAGEMENT_TYPES.SUCCESS]: { metricValue: 3 },
        [ENGAGEMENT_TYPES.WARNING]: { metricValue: 2 },
        [ENGAGEMENT_TYPES.DANGER]: { metricValue: 1 },
      }

      return gaugeValues[this.engagementResultType].metricValue
    },
    engagementText() {
      if (!this.engagementResultType) return

      // parar inverter o valor que vem no engagement
      const gaugeText = {
        [ENGAGEMENT_TYPES.SUCCESS]: {
          class: 'text-success',
          state: this.$t('engagement.types.success.state'),
          description: this.$t('engagement.types.success.description'),
        },
        [ENGAGEMENT_TYPES.WARNING]: {
          class: 'text-warning',
          state: this.$t('engagement.types.warning.state'),
          description: this.$t('engagement.types.warning.description'),
        },
        [ENGAGEMENT_TYPES.DANGER]: {
          class: 'text-danger',
          state: this.$t('engagement.types.danger.state'),
          description: this.$t('engagement.types.danger.description'),
        },
      }

      return gaugeText[this.engagementResultType]
    },
    engagementDescription() {
      const noDataDescriptionTranslation = this.noDataTranslation ? this.noDataTranslation.description : this.$t('engagement.no-data.description')

      return this.engagementResultType ? this.engagementText.description : noDataDescriptionTranslation
    },
    engagementState() {
      const noDataStateTranslation = this.noDataTranslation ? this.noDataTranslation.state : this.$t('engagement.no-data.state')

      return this.engagementResultType ? this.engagementText.state : noDataStateTranslation
    },
    engagementTextClass() {
      return this.engagementResultType ? this.engagementText.class : 'text-warning'
    },
  },

  data() {
    return {
      searchText: '',
    }
  },
  methods: {
    rotatePointer(deg) {
      if (!deg) return 0

      const typeList = {
        1: 'autoAnimationNeed',
        2: 'autoAnimationAverage',
        3: 'autoAnimationGood',
      }
      return typeList[deg] || 'autoAnimationNeed'
    },
  },
}
</script>

<style lang="scss" scoped>
.row-wrapper {
  width: fit-content;
}
.gap-20 {
  gap: 50px;
}
.gauge {
  width: 90px;
  height: 50px;
}
.engagement {
  color: $gray-600;
}
.engagement-span {
  font-size: $font-size-md;
}
.engagement-span-success {
  color: $success;
}
.engagement-subtitle {
  font-size: $font-size-xs;
  color: $gray-600;
}

.iconSearchPlaceholder::after {
  top: calc(50px - 34px) !important;
}

.inner-text {
  // allow the text to take all the available space in the svg on top of the gauge
  text-align: center;

  span {
    color: red;
    text-align: center;
  }
}
</style>

<style lang="scss">
.pointer {
  position: relative;
  left: 45%;
  width: 0;
  height: 0;
  top: calc(90% - 55px);
  border-left: 12px solid transparent;
  border-right: 12px solid transparent;
  border-bottom: 55px solid var(--gray-700);
  border-bottom-left-radius: 35%;
  border-bottom-right-radius: 35%;
  transform-origin: center bottom;
  transform: rotate(-100deg);
}

.animate {
  -webkit-transition-duration: 1.5s;
  -webkit-transition-property: 0 opacity;
  -webkit-transition-timing-function: ease;
  -moz-transition-duration: 1.5s;
  -o-transition-duration: 1.5s;
  transition-duration: 1.5s;
  -moz-transition-property: 0 opacity;
  -o-transition-property: 0 opacity;
  transition-property: 0 opacity;
  -moz-transition-timing-function: ease;
  -o-transition-timing-function: ease;
  transition-timing-function: ease;
}

@keyframes rotationNeed {
  from {
    transform: rotate(-100deg);
  }
  to {
    transform: rotate(-65deg);
  }
}

@keyframes rotationAverage {
  from {
    transform: rotate(-100deg);
  }
  to {
    transform: rotate(0deg);
  }
}

@keyframes rotationGood {
  from {
    transform: rotate(-100deg);
  }
  to {
    transform: rotate(65deg);
  }
}

.autoAnimationNeed {
  animation: rotationNeed 1500ms 1s forwards;
}
.autoAnimationAverage {
  animation: rotationAverage 1500ms 1s forwards;
}
.autoAnimationGood {
  animation: rotationGood 1500ms 1s forwards;
}
</style>
